"use client"
import Icon from '@ant-design/icons';
import type { GetProps } from 'antd';

type CustomIconComponentProps = GetProps<typeof Icon>;

const MapSvg = () => (
  <svg width="1em" height="1em" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.8799 3.36662L10.8799 2.03329H10.8333C10.8022 2.03017 10.771 2.03017 10.7399 2.03329H10.5866H10.4999H10.4533L6.66661 3.33329L2.87994 2.03329C2.77968 2.00023 2.67301 1.99145 2.5687 2.00768C2.46439 2.0239 2.36542 2.06467 2.27994 2.12662C2.19378 2.18797 2.12345 2.26893 2.07476 2.36283C2.02608 2.45672 2.00043 2.56086 1.99994 2.66662V12C1.99958 12.1397 2.04315 12.2761 2.1245 12.3897C2.20585 12.5034 2.32086 12.5886 2.45327 12.6333L6.45327 13.9666C6.58757 14.0104 6.73231 14.0104 6.86661 13.9666L10.6666 12.7L14.4533 14C14.5241 14.0096 14.5958 14.0096 14.6666 14C14.806 14.0019 14.9421 13.9573 15.0533 13.8733C15.1394 13.8119 15.2098 13.731 15.2585 13.6371C15.3071 13.5432 15.3328 13.4391 15.3333 13.3333V3.99996C15.3336 3.86019 15.2901 3.72385 15.2087 3.6102C15.1274 3.49655 15.0124 3.41135 14.8799 3.36662ZM5.99994 12.4066L3.33327 11.52V3.59329L5.99994 4.47996V12.4066ZM9.99994 11.52L7.33327 12.4066V4.47996L9.99994 3.59329V11.52ZM13.9999 12.4066L11.3333 11.52V3.59329L13.9999 4.47996V12.4066Z" fill="currentColor"/>
</svg>

)

const MapIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={MapSvg} {...props} />
);

export default MapIcon